// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RGaK0_IDgY0WWUbZrDMM{flex-direction:column;flex:1;justify-content:space-between;width:100%;display:flex;overflow:auto}.sY_qC0rLI2UIplRUzqJ8{background:var(--background-primary-inverted-primary);align-items:center;padding-top:16px;display:flex;position:-webkit-sticky;position:sticky;bottom:0;left:0}.sY_qC0rLI2UIplRUzqJ8 .ezFpYMCaZTMbuILuN7qF{background-color:var(--border-neutral-primary);width:1px;height:12px;margin:0 8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filterContainer": `RGaK0_IDgY0WWUbZrDMM`,
	"filterActions": `sY_qC0rLI2UIplRUzqJ8`,
	"divider": `ezFpYMCaZTMbuILuN7qF`
};
export default ___CSS_LOADER_EXPORT___;
